<template>
    <v-card class="statisticsEventsDetail pa-3 pt-0">
        <v-card-text>
            <v-skeleton-loader v-if="stats.MSG_SENT === undefined" type="article, list-item-two-line" ></v-skeleton-loader>

            <template v-else>
                <v-hover v-slot="{ hover }">
                    <div>
                        <v-row>
                            <v-col cols="6" v-for="(event, key) in stats.events">
                                <div class="d-flex justify-space-between mb-1 label"><span>{{ $t("event_" + key) }}</span><span :style="'color: ' + event.color + ';'">{{ hover ? event.count : (getPercent(event.count, stats.events.MSG_SENT.count) + "%") }}</span></div>
                                <v-progress-linear :color="event.color" :value="getPercent(event.count, stats.events.MSG_SENT.count)"></v-progress-linear>
                            </v-col>
                        </v-row>
                    </div>
                </v-hover>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "statisticsEventsDetail",
    props: ["stats"],
    data() {
        return {
        }
    },
    methods: {
        getPercent(value, total) {
            if(!total) return 0;
            return +(value * 100 / total).toFixed(2);
        },
    },
}
</script>

<style lang="scss">
    .statisticsEventsDetail {
        .hover:hover {

        }
    }
</style>